import AddClaimant from "./AddClaimant";

export default AddClaimant;